<template>
  <div class="goLogin">
    <div class="successBg">
      <img :src="successBg" alt="注册成功图" />
    </div>
    <p class="successTip">恭喜您！账号注册完成，待管理员认证后即可进行登录！</p>
    <el-button type="primary" @click="goLogin">点击返回</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      successBg: require('assets/images/register-success.png')
    };
  },
  methods: {
    goLogin() {
      sessionStorage.clear();
      this.$router.replace('/login');
    }
  }
};
</script>
<style lang="less" scoped>
.goLogin {
  height: 416px;
  width: 100%;
  margin: 0 auto;
  .successBg {
    margin: 0 auto;
    width: 85px;
    height: 85px;
    background: #67c33a;
    border-radius: 50%;
    margin-top: 105px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .successTip {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #67c33a;
    margin-top: 28px;
  }
  /deep/.el-button--primary {
    width: 410px;
    background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
    box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
    border-radius: 20px;
    display: block;
    margin: 0 auto;
    margin-top: 164px;
  }
}
</style>
